Shopify.theme.jsTestimonials = {
    init: function ($section) {
        const $testimonialSlider = $section.find('[data-slider]');

        $testimonialSlider.flickity({
            wrapAround: false,
            initialIndex: 0,
            prevNextButtons: false,
            cellAlign: 'left',
            pageDots: true,
            watchCSS: true
        });

        // Cache the custom navigation buttons
        const $prevButton = $section.find('.testimonial__nav--prev');
        const $nextButton = $section.find('.testimonial__nav--next');

        // Disable buttons if at the start or end
        $testimonialSlider.on('select.flickity', function () {
            const flkty = $testimonialSlider.data('flickity');

            // Disable the "prev" button if we're at the first slide
            if (flkty.selectedIndex === 0) {
                $prevButton.addClass('disable');
            } else {
                $prevButton.removeClass('disable');
            }

            // Disable the "next" button if we're at the last slide
            if (flkty.selectedIndex === flkty.slides.length - 1) {
                $nextButton.addClass('disable');
            } else {
                $nextButton.removeClass('disable');
            }
        });

        // Navigate to the previous slide
        $section.on('click', '.testimonial__nav--prev', function () {
            $testimonialSlider.flickity('previous');
        });

        // Navigate to the next slide
        $section.on('click', '.testimonial__nav--next', function () {
            $testimonialSlider.flickity('next');
        });

        // Trigger the event manually to set initial button states
        $testimonialSlider.trigger('select.flickity');
    },
    blockSelect: function ($section, blockId) {
        const $testimonialSlider = $section.find('[data-slider]');

        const slideIndex = $('#shopify-section-' + blockId).data('index');

        $testimonialSlider.flickity('select', slideIndex);
    },
    unload: function ($section) {
        const $slider = $section.find('.flickity-enabled');
        $slider.flickity('destroy');
        $section.find('.testimonial__nav--prev').off();
        $section.find('.testimonial__nav--next').off();
    }
};
